import { render, staticRenderFns } from "./AccusationExtended.vue?vue&type=template&id=6b7a4d30&"
import script from "./AccusationExtended.vue?vue&type=script&lang=js&"
export * from "./AccusationExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports